import { render } from "./QuranPageCard.vue?vue&type=template&id=3b60e58d"
import script from "./QuranPageCard.vue?vue&type=script&lang=js"
export * from "./QuranPageCard.vue?vue&type=script&lang=js"
script.render = render

export default script